import type { JSX } from '@familyjs/core/components';
import { defineCustomElement as defineFmlApp } from '@familyjs/core/components/fml-app.js';
import { defineCustomElement as defineFmlBackButton } from '@familyjs/core/components/fml-back-button.js';
import { defineCustomElement as defineFmlRouterOutlet } from '@familyjs/core/components/fml-router-outlet.js';
import { defineCustomElement as defineFmlTabBar } from '@familyjs/core/components/fml-tab-bar.js';
import { defineCustomElement as defineFmlTabButton } from '@familyjs/core/components/fml-tab-button.js';
import type { JSX as FamiconsJSX } from 'famicons';
import { defineCustomElement as defineFmlIcon } from 'famicons/components/fml-icon.js';

import { createReactComponent } from './react-component-lib';

export const FmlTabButtonInner = /*@__PURE__*/ createReactComponent<
  JSX.FmlTabButton & { onFmlTabButtonClick?: (e: CustomEvent) => void },
  HTMLFmlTabButtonElement
>('fml-tab-button', undefined, undefined, defineFmlTabButton);
export const FmlTabBarInner = /*@__PURE__*/ createReactComponent<JSX.FmlTabBar, HTMLFmlTabBarElement>(
  'fml-tab-bar',
  undefined,
  undefined,
  defineFmlTabBar
);
export const FmlBackButtonInner = /*@__PURE__*/ createReactComponent<
  Omit<JSX.FmlBackButton, 'icon'>,
  HTMLFmlBackButtonElement
>('fml-back-button', undefined, undefined, defineFmlBackButton);
export const FmlRouterOutletInner = /*@__PURE__*/ createReactComponent<
  JSX.FmlRouterOutlet & {
    setRef?: (val: HTMLFmlRouterOutletElement) => void;
    forwardedRef?: React.ForwardedRef<HTMLFmlRouterOutletElement>;
  },
  HTMLFmlRouterOutletElement
>('fml-router-outlet', undefined, undefined, defineFmlRouterOutlet);

export const FmlAppInner = /*@__PURE__*/ createReactComponent<JSX.FmlApp, HTMLFmlAppElement>(
  'fml-app',
  undefined,
  undefined,
  defineFmlApp
);

// famicons
export const FmlIconInner = /*@__PURE__*/ createReactComponent<FamiconsJSX.FmlIcon, HTMLFmlIconElement>(
  'fml-icon',
  undefined,
  undefined,
  defineFmlIcon
);
